import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import FormControl from '@mui/material/FormControl'
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';

const ProductDimensions = ({open, close, ...rest}) => {
  const app = React.useContext(AppContext)
  const { selectedProducts, setSelectedProducts, assignDimensions, getProducts } = app.products
  const [width, setWidth] = React.useState()
  const [height, setHeight] = React.useState()
  const [depth, setDepth] = React.useState()
  const [weight, setWeight] = React.useState()
  const dimensionChange = (name) => (e) => {
    const target = e.target? e.target:e.currentTarget
    if(!isNaN(target.value)){
      const value = target.value.indexOf(".")>=0 ? target.value : Number(target.value)
      if(name === 'width')
        setWidth(value)
      if(name === 'height')
        setHeight(value)
      if(name === 'depth')
        setDepth(value)
      if(name === 'weight')
        setWeight(value)
    }
  }
  const updateDimensions = () => {
    assignDimensions({width, height, depth, weight, })
    close()
  }
  const skus = (ps) => ps.reduce((pv, p) => pv ? `${pv}, ${p.sku}` : p.sku, false)
  const name = () => selectedProducts.length === 1? `Asignar Dimensiones a: ${getProducts(selectedProducts)[0].name}`: `Asignar Dimensiones a ${selectedProducts.length} productos con SKUs: (${skus(getProducts(selectedProducts))})`

  React.useEffect(() => {
    if(selectedProducts && selectedProducts.length === 1){
      const ps = getProducts(selectedProducts)
      setHeight(ps[0].productdimension?ps[0].productdimension.height : null)
      setWidth(ps[0].productdimension?ps[0].productdimension.width : null)
      setDepth(ps[0].productdimension?ps[0].productdimension.depth : null)
      setWeight(ps[0].productdimension?ps[0].productdimension.weight : null)
    }
    else{
      setHeight(null)
      setWidth(null)
      setDepth(null)
      setWeight(null)
    }
  }, [selectedProducts])

  return (
    <Dialog onClose={() => setSelectedProducts(false)} open={open}>
    {selectedProducts && 
      <React.Fragment>
        <DialogTitle>{name()}</DialogTitle>
          <Box padding="15px" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'start'}}>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <TextField
                id="height"
                value={height}
                onChange={dimensionChange('height')}
                label="Alto"
                InputProps={{
                  endAdornment: <InputAdornment position="end">cm</InputAdornment>,
                }}
            />
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <TextField
                id="width"
                value={width}
                onChange={dimensionChange('width')}
                label="Ancho"
                InputProps={{
                  endAdornment: <InputAdornment position="end">cm</InputAdornment>,
                }}
            />
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <TextField
                id="depth"
                value={depth}
                onChange={dimensionChange('depth')}
                label="Largo"
                InputProps={{
                  endAdornment: <InputAdornment position="end">cm</InputAdornment>,
                }}
            />
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <TextField
                id="weight"
                value={weight}
                onChange={dimensionChange('weight')}
                label="Peso"
                InputProps={{
                  endAdornment: <InputAdornment position="end">g</InputAdornment>,
                }}
            />
            </FormControl>
          </Box>
        <Button disabled={ isNaN(height) || isNaN(width) || isNaN(depth) || isNaN(weight) } onClick={updateDimensions}>Actualizar dimensiones</Button>
      </React.Fragment>
    }
    </Dialog>
  )
}
export default ProductDimensions